import React from 'react';
import { Button } from './Button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
// Since we don't have the Table component yet, I'll implement a simple one here
// or I can create components/ui/Table.tsx in the next batch.
// For now, I'll implement a self-contained table structure.
interface Column<T> {
  header: string;
  accessorKey?: keyof T;
  cell?: (item: T) => React.ReactNode;
  className?: string;
}
interface DataTableProps<T> {
  data: T[];
  columns: Column<T>[];
  keyExtractor: (item: T) => string | number;
  onRowClick?: (item: T) => void;
}
export function DataTable<T>({
  data,
  columns,
  keyExtractor,
  onRowClick
}: DataTableProps<T>) {
  return <div className="w-full overflow-auto rounded-md border bg-white shadow-sm" data-id="element-292">
      <table className="w-full caption-bottom text-sm" data-id="element-293">
        <thead className="[&_tr]:border-b" data-id="element-294">
          <tr className="border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted" data-id="element-295">
            {columns.map((col, index) => <th key={index} className="h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0" data-id="element-296">
                {col.header}
              </th>)}
          </tr>
        </thead>
        <tbody className="[&_tr:last-child]:border-0" data-id="element-297">
          {data.length > 0 ? data.map(row => <tr key={keyExtractor(row)} className={`border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted ${onRowClick ? 'cursor-pointer' : ''}`} onClick={() => onRowClick && onRowClick(row)} data-id="element-298">
                {columns.map((col, index) => <td key={index} className={`p-4 align-middle [&:has([role=checkbox])]:pr-0 ${col.className || ''}`} data-id="element-299">
                    {col.cell ? col.cell(row) : col.accessorKey ? row[col.accessorKey] as React.ReactNode : null}
                  </td>)}
              </tr>) : <tr data-id="element-300">
              <td colSpan={columns.length} className="h-24 text-center" data-id="element-301">
                Tidak ada data.
              </td>
            </tr>}
        </tbody>
      </table>
      <div className="flex items-center justify-between py-4 px-4 border-t" data-id="element-302">
        <div className="text-xs text-muted-foreground" data-id="element-303">
          Menampilkan {data.length} data
        </div>
        <div className="space-x-2" data-id="element-304">
          <Button variant="outline" size="sm" disabled data-id="element-305">
            <ChevronLeft className="h-4 w-4" data-id="element-306" />
          </Button>
          <Button variant="outline" size="sm" disabled data-id="element-307">
            <ChevronRight className="h-4 w-4" data-id="element-308" />
          </Button>
        </div>
      </div>
    </div>;
}